var _rect, _rect2, _rect3, _rect4, _circle, _rect5, _rect6, _rect7, _circle2, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgReplyNodata(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 390,
    height: 200,
    viewBox: "0 0 390 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 153,
    width: 286,
    height: 13,
    rx: 2,
    fill: "#EEE"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 170,
    width: 206,
    height: 13,
    rx: 2,
    fill: "#EEE"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 187,
    width: 252,
    height: 13,
    rx: 2,
    fill: "#EEE"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 111,
    width: 149,
    height: 24,
    rx: 2,
    fill: "#EEE"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 125,
    r: 24,
    fill: "#EEE"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 52,
    width: 286,
    height: 13,
    rx: 2,
    fill: "#EEE"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 69,
    width: 206,
    height: 13,
    rx: 2,
    fill: "#EEE"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 10,
    width: 149,
    height: 24,
    rx: 2,
    fill: "#EEE"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 24,
    r: 24,
    fill: "#EEE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M331.817 13.633a6.162 6.162 0 0 0-2.274-1.33 6.196 6.196 0 0 0-5.12.593 6.125 6.125 0 0 0-1.904 1.813c0 .082-.295.433-.519.83-.224-.397-.46-.748-.519-.83a6.125 6.125 0 0 0-1.904-1.813 6.178 6.178 0 0 0-5.12-.593 6.162 6.162 0 0 0-2.274 1.33c-2.961 2.808-2.584 7.313-.802 10.707 2.077 3.955 5.899 6.12 9.758 8.039.22.12.446.23.677.33.14.06.299.06.439 0 .231-.1.457-.21.677-.33 3.788-1.978 7.646-4.143 9.687-8.04 1.782-3.393 2.159-7.898-.802-10.706z",
    fill: "#EEE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#gezxtqrx5a)",
    d: "M0 0h390v200H0z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gezxtqrx5a",
    x1: 195,
    y1: 7.186,
    x2: 195,
    y2: 258.376,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.089
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgReplyNodata);
export default __webpack_public_path__ + "static/media/img_reply_nodata.0c773df6f113b5651191c5226761f8ed.svg";
export { ForwardRef as ReactComponent };